import { createUseStyles } from 'react-jss'

import { colors, desktop, notDesktop } from '../../theme'


export const variants = {
  Transparent: 'transparent',
  BigTransparent: 'bigtransparent',
  BigWhite: 'bigwhite',
  BlackOnWhite: 'blackOnWhite',
}

export const theming = {
  container: {
    padding: {
      [variants.Transparent]: '0.6rem 1rem 0.4rem',
      [variants.BigTransparent]: '1rem 1rem 0.6rem',
      [variants.BigWhite]: '1rem 1rem 0.6rem',
      [variants.BlackOnWhite]: '1rem 1rem 0.6rem',
    },
    backgroundColor: {
      [variants.Transparent]: 'none',
      [variants.BigTransparent]: 'none',
      [variants.BigWhite]: colors.pureWhite,
      [variants.BlackOnWhite]: colors.pureWhite,
    },
    borderColor: {
      [variants.Transparent]: colors.pureWhite,
      [variants.BigTransparent]: colors.pureWhite,
      [variants.BigWhite]: colors.pureWhite,
      [variants.BlackOnWhite]: colors.pureBlack,
    },
    color: {
      [variants.Transparent]: colors.pureWhite,
      [variants.BigTransparent]: colors.pureWhite,
      [variants.BigWhite]: colors.pureBlack,
      [variants.BlackOnWhite]: colors.pureBlack,
    },
  },
  hover: {
    backgroundColor: {
      [variants.Transparent]: colors.pureWhite,
      [variants.BigTransparent]: colors.pureWhite,
      [variants.BigWhite]: colors.pureWhite,
      [variants.BlackOnWhite]: colors.pureBlack,
    },
    color: {
      [variants.Transparent]: colors.pureBlack,
      [variants.BigTransparent]: colors.pureBlack,
      [variants.BigWhite]: colors.pureBlack,
      [variants.BlackOnWhite]: colors.pureWhite,
    },
  },
}

export default createUseStyles({
  container: {
    position: 'relative',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: (props) => theming.container.padding[props.variant],
    border: (props) => (props.hasBorder ? `1px solid ${theming.container.borderColor[props.variant]}` : 'none'),
    borderRadius: '0.8rem',
    color: (props) => theming.container.color[props.variant],
    fontSize: '1.2rem',
    lineHeight: '1.2',
    textTransform: 'uppercase',
    textAlign: 'center',
    backgroundColor: (props) => (theming.container.backgroundColor[props.variant]
      ? theming.container.backgroundColor[props.variant]
      : colors.pureBlack),
    transition: 'all 300ms ease-in-out',
    ...notDesktop({
      '@media (hover: hover)': {
        '&:hover': {
          color: (props) => theming.hover.color[props.variant],
          backgroundColor: (props) => theming.hover.backgroundColor[props.variant],
        },
      },
    }),
    ...desktop({
      '&:hover': {
        color: (props) => `${theming.hover.color[props.variant]} !important`,
        backgroundColor: (props) => `${theming.hover.backgroundColor[props.variant]} !important`,
      },
    }),
  },
  textContainer: {},
  text: {},
})
